// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as JsxPPXReactSupportC from "rescript/lib/es6/jsxPPXReactSupportC.js";
import * as DndKit$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/DndKit.res.mjs";
import * as ContextMaker$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/ContextMaker.res.mjs";
import * as V3PunctuationTypes$LiteracyplanetTupperware from "./V3PunctuationTypes.res.mjs";

var DndApiSig = {
  name: "V3DndPunctuationBehaviour"
};

var DndApi = ContextMaker$LiteracyplanetClientFlags.Make(DndApiSig);

var DndSig = {};

var Dnd = DndKit$LiteracyplanetClientFlags.Make(DndSig);

function V3DndPunctuationBehaviour$SortContext(props) {
  var items = props.items;
  var match = React.useState(function (param) {
        return items;
      });
  var setItems = match[1];
  var items$1 = match[0];
  var match$1 = V3PunctuationTypes$LiteracyplanetTupperware.splitItems(items$1);
  var onDragEnd = function (param) {
    var over = param.over;
    var active = param.active;
    if (active.TAG !== "SortPunctuation") {
      return ;
    }
    var drag = active.id;
    if (over !== undefined) {
      if (over.TAG === "SortPunctuation") {
        return ;
      } else {
        var drop = over.id;
        return Curry._1(setItems, (function (items) {
                      var foundEnd = {
                        contents: false
                      };
                      return Belt_Array.map(V3PunctuationTypes$LiteracyplanetTupperware.sortItems(items, drag, drop), (function (item) {
                                    if (!foundEnd.contents) {
                                      if (item.kind === "CharacterEnd") {
                                        foundEnd.contents = true;
                                        return item;
                                      } else {
                                        return item;
                                      }
                                    }
                                    var match = item.kind;
                                    if (typeof match !== "object") {
                                      return item;
                                    } else {
                                      return {
                                              id: item.id,
                                              text: item.text,
                                              kind: {
                                                TAG: "Punctuation",
                                                placed: false,
                                                useValueForMarking: match.useValueForMarking,
                                                distractor: match.distractor
                                              }
                                            };
                                    }
                                  }));
                    }));
      }
    } else {
      return Curry._1(setItems, (function (items) {
                    return V3PunctuationTypes$LiteracyplanetTupperware.removeItem(items, drag);
                  }));
    }
  };
  Curry._5(Dnd.useDndMonitor, undefined, undefined, onDragEnd, undefined, undefined);
  return React.createElement(DndApi.Provider.make, {
              value: {
                punctuation: match$1[0],
                characters: match$1[1],
                items: items$1,
                setItems: setItems
              },
              children: React.createElement(Dnd.SortableContext.make, {
                    id: Caml_option.some(props.id),
                    vertical: false,
                    items: items$1,
                    children: props.children
                  })
            });
}

var SortContext = {
  make: V3DndPunctuationBehaviour$SortContext
};

function V3DndPunctuationBehaviour$DragOverlay(props) {
  var render = props.render;
  var context = Curry._1(Dnd.useDndContext, undefined);
  var match = Curry._1(DndApi.use, undefined);
  var items = match.items;
  return React.createElement(Dnd.DragOverlay.make, {
              children: Belt_Option.mapWithDefault(context.active, null, (function (t) {
                      var tmp;
                      if (t.TAG === "SortPunctuation") {
                        var id = t.id;
                        tmp = Caml_option.undefined_to_opt(items.find(function (p) {
                                  return p.id === id;
                                }));
                      } else {
                        tmp = undefined;
                      }
                      return Curry._1(render, tmp);
                    }))
            });
}

var DragOverlay = {
  make: V3DndPunctuationBehaviour$DragOverlay
};

function V3DndPunctuationBehaviour$DraggablePunctuation(props) {
  var id = props.id;
  return JsxPPXReactSupportC.createElementWithKey(id, Dnd.DraggableItem.make, {
              id: id,
              className: props.className,
              t: {
                TAG: "SortPunctuation",
                id: id
              },
              dom: "div",
              handle: true,
              hideOnDrag: true,
              children: props.children
            });
}

var DraggablePunctuation = {
  make: V3DndPunctuationBehaviour$DraggablePunctuation
};

function V3DndPunctuationBehaviour$SortableCharacters(props) {
  var id = props.id;
  return JsxPPXReactSupportC.createElementWithKey(id, Dnd.SortableItem.make, {
              id: id,
              className: props.className,
              t: {
                TAG: "SortCharacters",
                id: id
              },
              dom: "div",
              handle: false,
              children: props.children
            });
}

var SortableCharacters = {
  make: V3DndPunctuationBehaviour$SortableCharacters
};

function V3DndPunctuationBehaviour$DndProvider(props) {
  return React.createElement(Dnd.Provider.make, {
              children: props.children
            });
}

var DndProvider = {
  make: V3DndPunctuationBehaviour$DndProvider
};

export {
  DndApiSig ,
  DndApi ,
  DndSig ,
  Dnd ,
  SortContext ,
  DragOverlay ,
  DraggablePunctuation ,
  SortableCharacters ,
  DndProvider ,
}
/* DndApi Not a pure module */
